import { Vue, Component } from 'vue-property-decorator';
import { mutations } from '@/store/types';

@Component
export default class LoadableMixin extends Vue {
    setLoading(loading: boolean) {
        this.$store.commit(mutations.LOADING, { loading });
    }
    async load(loadingAsynFn: any, errorMessage?: string, successMessage?: string) {
        try {
            this.setLoading(true);

            await loadingAsynFn();

            if (successMessage) {
                this.$toasted.success(successMessage);
            }
        } catch (error) {
            if (errorMessage) {
                this.$toasted.error(errorMessage);
            }
        } finally {
            this.setLoading(false);
        }
    }
}
